export default async function uploadByPart(url: string, body: Blob) {
  return await fetch(url, {
    headers: {
      "Content-Type": "application/octet-stream",
    },
    method: "PUT",
    body: body,
  });
}
